import React from "react";
import { UiSlider } from "../common/UiSlider";
import {
    UiNextArrow,
    UiPrevArrow,
} from "../common/UiSliderArrows";


export const UiStepsWizard = (props) => {

    const wizardData = props.wizardData;

    const WizardSlider = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        centerPadding: 30,
        slidesToScroll: 1,
        nextArrow: <UiNextArrow />,
        prevArrow: <UiPrevArrow />,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                },
            },
        ],
    };

    return (
        <>
            <div className="sb-step-wizard-slider">
                <UiSlider
                    UiSliderSettings={WizardSlider} >
                    {wizardData.map((data, index) =>
                        <div>
                            <div className="sb-step-wizard-wrapper">
                                <div className={
                                    data.status == "active" ? 'sb-step-wizard-wrapper-item active' :
                                        data.status == "success" ? 'sb-step-wizard-wrapper-item success' :
                                            data.status == "disabled" ? 'sb-step-wizard-wrapper-item disabled' :
                                                'sb-step-wizard-wrapper-item '}
                                    key={index}
                                >
                                    <div>
                                        <h1>{data.number}</h1>
                                        <h5>{data.title}</h5>
                                        <p>{data.content}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </UiSlider>
            </div>
        </>
    )
}